import { RootState } from '@/shared/store'

import { runsAdapter } from './runsAdapter'

export const runsSelectors = runsAdapter.getSelectors<RootState>(
  (state) => state.runs,
)
